import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/produto-servico`;

const produtoServicoApi = {
  pesquisar: (params) => {
    const url = `${getPath()}/pesquisar`;
    return axios.get(url, { params });
  },
};

export { produtoServicoApi };
